import { FormInput, CalendarClock, UserPlus, Mail } from "lucide-react";

const VARIANTS = {
  candidate: {
    icon: UserPlus,
    title: "Candidate Registration",
    description:
      "Your HubSpot candidate registration form will live here. Drop in the embed code or portal ID to activate.",
    note: "HubSpot Form Embed",
  },
  employer: {
    icon: CalendarClock,
    title: "Book a discovery call",
    description:
      "Your HubSpot meetings/booking widget will live here. Replace this placeholder with your scheduling embed.",
    note: "HubSpot Meetings Embed",
  },
  contact: {
    icon: Mail,
    title: "Send us a message",
    description:
      "Your HubSpot contact form will live here. Add your form ID and portal ID to go live.",
    note: "HubSpot Form Embed",
  },
  default: {
    icon: FormInput,
    title: "Form placeholder",
    description: "Configure HubSpot embed to activate.",
    note: "HubSpot Embed",
  },
};

export default function HubspotPlaceholder({ formType = "default" }) {
  const variant = VARIANTS[formType] || VARIANTS.default;
  const Icon = variant.icon;

  return (
    <div
      data-testid={`hubspot-placeholder-${formType}`}
      className="w-full border-2 border-dashed border-ink-200 bg-mint-soft rounded-2xl p-10 md:p-14 flex flex-col items-center justify-center text-center min-h-[320px] relative overflow-hidden"
    >
      <div className="absolute top-4 right-4 text-[10px] uppercase tracking-[0.25em] font-body font-medium text-ink-700 bg-cream px-3 py-1 rounded-full border border-ink-100">
        {variant.note}
      </div>
      <div className="w-16 h-16 rounded-full bg-ink text-mint flex items-center justify-center mb-6">
        <Icon size={26} strokeWidth={1.5} />
      </div>
      <h3 className="font-headings text-2xl md:text-3xl text-ink mb-3">{variant.title}</h3>
      <p className="font-body text-ink-700 max-w-md text-base md:text-lg leading-relaxed">
        {variant.description}
      </p>
    </div>
  );
}
